module.exports = __webpack_public_path__ + "img/task-list-icon.b4d2e461.svg";